// PALIATIVO (temporario): a quebra de limite volta a ser decidida apenas pelo min/max de cada
// campo (o localBroken que cada celula ja calcula), ignorando o veredito da API
// (brokenLimit/brokenLimitTypes). Para restaurar o comportamento anterior, trocar a flag para
// true e remover este bloco junto com o early return em shouldHighlightBrokenLimit.
const USE_API_BROKEN_LIMIT = false;

export type BrokenLimitCellType = 'MARGIN' | 'COMPETITIVENESS' | 'PRICE_LIST';

type LimitApiRowData = Record<string, unknown>;

type ShouldHighlightBrokenLimitParams = {
  rowData: LimitApiRowData;
  localBroken: boolean;
  type: BrokenLimitCellType;
};

export const apiTypesByCellType: Record<BrokenLimitCellType, readonly string[]> = {
  MARGIN: ['MARGIN', 'OBJECTIVE_MARGIN'],
  COMPETITIVENESS: ['COMPETITIVENESS'],
  PRICE_LIST: ['PRICE_LIST'],
};

const hasValue = (value: unknown): boolean => value !== null && value !== undefined;

export const matchesEvaluatedPrice = (rowData: LimitApiRowData): boolean => {
  const { price, priceStatus, retailPrice, suggestedPrice } = rowData;

  if (!hasValue(price)) return false;

  if (priceStatus === 'AUTO' || priceStatus === 'OTIMIZADO') {
    return hasValue(suggestedPrice) && price === suggestedPrice;
  }

  if (priceStatus === 'ERP') {
    return !hasValue(suggestedPrice) && hasValue(retailPrice) && price === retailPrice;
  }

  return false;
};

export const shouldHighlightBrokenLimit = ({ rowData, localBroken, type }: ShouldHighlightBrokenLimitParams): boolean => {
  if (!USE_API_BROKEN_LIMIT) return localBroken;

  const { brokenLimit, brokenLimitTypes, priceStatus } = rowData;

  if (priceStatus === 'EDITED' || priceStatus === 'EDITADO') return localBroken;
  if (brokenLimit !== true || !Array.isArray(brokenLimitTypes)) return false;

  const matchesCellType = apiTypesByCellType[type].some(apiType => brokenLimitTypes.includes(apiType));

  return matchesCellType && matchesEvaluatedPrice(rowData);
};
